import { cn } from "@/helper/HelperFunction";
import Statuses from "../Core/Statuses";
import classes from "./ViewField.module.css";
function ViewField({
  label,
  labelStyles,
  value,
  type = "text",
  rightIcon,
  variant = "primary",
  inputClass,
}) {
  return (
    <div
      className={cn(classes.main, variant === "secondary" && classes.secondary)}
    >
      <p className={classes.label} style={labelStyles}>
        {label}
      </p>
      <div
        className={[
          type === "status" && classes.status,
          classes.value,
          type === "textarea" && classes.textarea,
          type === "input" && classes.input,
          inputClass && inputClass,
        ].join(" ")}
      >
        {type === "status" ? (
          <Statuses status={value} />
        ) : (
          <p>{value || "N/A"}</p>
        )}{" "}
        {type === "text" && <span>{rightIcon}</span>}
      </div>
    </div>
  );
}

export default ViewField;
